import { get_url_api } from 'utils/getConfigUrls';

if (process.env.API_MICROSERVICES_URL) {
    if (!window.Config) {
        window.Config = {
            api_microservices: process.env.API_MICROSERVICES_URL,
        };
    }
}

export const API_MICROSERVICES_URL_BASE = window.Config.api_microservices; // Example: https://api.dev.salesmessage.com/qa/int/v5/

export const GET_API_MICROSERVICE = () => {
    return get_url_api(API_MICROSERVICES_URL_BASE);
};

export const API_MICROSERVICES_URL = GET_API_MICROSERVICE();
